import React, { useState } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { RefreshIcon } from "../../icons";
import { useServiceWorker } from '../hooks/useServiceWorker';

export const UpdateNotification: React.FC = () => {
  const { updateAvailable, applyUpdate } = useServiceWorker();
  const [dismissed, setDismissed] = useState(false);

  const handleUpdate = () => {
    applyUpdate();
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  if (!updateAvailable || dismissed) {
    return null;
  }

  return (
    <Snackbar
      open={updateAvailable && !dismissed}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 8 }}
    >
      <Alert
        severity="info"
        onClose={handleDismiss}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={handleUpdate}
            startIcon={<RefreshIcon />}
          >
            Actualizar
          </Button>
        }
      >
        Nueva versión disponible
      </Alert>
    </Snackbar>
  );
};
